<script setup lang="ts">
import { defineAsyncComponent } from 'vue'
import { useIntersectionObserver } from '@vueuse/core'

const ECharts = defineAsyncComponent(async () => {
  await import('./echarts-init')
  const m = await import('vue-echarts')
  return m.default || m
})

defineProps<{
  option: Record<string, unknown>
  autoresize?: boolean
  updateOptions?: { notMerge?: boolean; lazyUpdate?: boolean }
}>()

// echarts is loaded and drawn only when the chart nears the viewport: below the fold
// (on /deposits under the list of offers) it used to take ~150 ms of the main thread
// right after hydration (#296). The root keeps the size the caller gives it.
const root = ref<HTMLElement | null>(null)
const isNearViewport = ref(false)

const { stop } = useIntersectionObserver(
  root,
  ([entry]) => {
    if (!entry?.isIntersecting) return
    isNearViewport.value = true
    stop()
  },
  { rootMargin: '300px' }
)
</script>

<template>
  <div ref="root">
    <ECharts
      v-if="isNearViewport"
      class="size-full"
      :option="option"
      :autoresize="autoresize"
      :update-options="updateOptions"
    />
  </div>
</template>
